import React, { useMemo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Badge, Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { SortableElement, SortableHandle } from 'react-sortable-hoc';
import FormSwitch from '../../../../../../components/FormSwitch';
import { routesAppearance } from '../../../../helpers';

// eslint-disable-next-line react/prop-types
const Handle = () => (
  <svg className="languages-table__handle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 20">
    <path d="M7 2c-1.104 0-2 .896-2 2s.896 2 2 2 2-.896 2-2-.896-2-2-2zm0 6c-1.104 0-2 .896-2 2s.896 2 2 2 2-.896 2-2-.896-2-2-2zm0 6c-1.104 0-2 .896-2 2s.896 2 2 2 2-.896 2-2-.896-2-2-2zm6-8c1.104 0 2-.896 2-2s-.896-2-2-2-2 .896-2 2 .896 2 2 2zm0 2c-1.104 0-2 .896-2 2s.896 2 2 2 2-.896 2-2-.896-2-2-2zm0 6c-1.104 0-2 .896-2 2s.896 2 2 2 2-.896 2-2-.896-2-2-2z" />
  </svg>
)

export const SortHandle = SortableHandle((props) => <Handle {...props} />);

const Row = ({ id, active, code, modified, name, config, onChangeVisibility, ...props }) => {
  const history = useHistory();
  const routeEditPage = useMemo(() => routesAppearance.find((route) => route.code === 'edit-language'), [])

  const updatedSplit = modified.split(' ');
  const firstDate = updatedSplit[0];
  const secondDate = updatedSplit[1];
  const isDisabledVisibility = !config?.access?.languages_toggle_visibility;

  const onEditLanguage = (code) => {
    if (code) {
      history.push({
        pathname: routeEditPage.link,
        search: `?code=${code}`,
      })
    }
  }

  return (
    <tr
      className={classNames({
        grey: !active,
      })}
    >
      <td className="languages-table__name">
        <div>
          {config?.access?.languages_edit_position ? <SortHandle /> : null }
          {name}
          {' '}
          {props.default ? <Badge>Default</Badge> : null}
        </div>
      </td>
      <td className="languages-table__visibility">
        <FormSwitch
          onChange={() => onChangeVisibility(code, !active)}
          disabled={props.default || isDisabledVisibility}
          checked={!!active}
        />
      </td>
      <td className="languages-table__updated">
        <span>{firstDate}</span>
        {' '}
        {secondDate ? <span>{secondDate}</span> : null }
      </td>
      {config?.access?.languages_translations_list
        ? (
          <td className="p-r text-right languages-table__actions">
            <Button onClick={() => onEditLanguage(code)} bsSize="xsmall">Edit</Button>
          </td>
        ) : null}
    </tr>
  )
};

Row.propTypes = {
  default: PropTypes.bool,
  isLoading: PropTypes.bool,
  items: PropTypes.array,
  config: PropTypes.object,
  onChangeVisibility: PropTypes.func,
  id: PropTypes.number,
  active: PropTypes.bool,
  code: PropTypes.string,
  modified: PropTypes.string,
  name: PropTypes.string,
};

export default SortableElement(Row);
